import React, { useState, useMemo } from 'react';
import { Box, Typography, Avatar, ListItem, ListItemIcon, ListItemText, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ProfileInfo from './ProfileInfo';
import { useSelector } from 'react-redux';
import { ProfilePath } from '../../../API/config';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import VerifiedIcon from '@mui/icons-material/Verified';

const ProfileSection = () => {
  const theme = useTheme();
  const [avatarDrawerOpen, setAvatarDrawerOpen] = useState(false);
  const user = useSelector((state) => state.user?.data || {});
  const mineKyc = useSelector((state) => state.kyc?.mine || null);

  const handleAvatarDrawerToggle = () => {
    setAvatarDrawerOpen(!avatarDrawerOpen);
  };

  // استخراج حالة KYC من قاعدة البيانات أو من user
  const kycStatus = useMemo(() => {
    const raw = (mineKyc?.status || user?.kyc_status || 'unverified');
    return String(raw).toLowerCase();
  }, [mineKyc, user]);

  // تحديد الشارة المناسبة
  const statusChip = useMemo(() => {
    switch (kycStatus) {
      case 'verified':
      case 'approved':
        return (
          <Chip
            icon={<VerifiedIcon sx={{ fontSize: 15 }} />}
            label="Verified"
            color="success"
            size="small"
            sx={{
              height: 20,
              fontSize: '0.7rem',
              '& .MuiChip-label': { px: 0.5 },
            }}
          />
        );
      case 'pending':
        return (
          <Chip
            icon={<HourglassBottomIcon sx={{ fontSize: 14 }} />}
            label="Under Review"
            color="warning"
            size="small"
            sx={{
              height: 20,
              fontSize: '0.7rem',
              '& .MuiChip-label': { px: 0.5 },
            }}
          />
        );
      case 'rejected':
        return (
          <Chip
            icon={<HighlightOffIcon sx={{ fontSize: 14 }} />}
            label="Rejected"
            color="error"
            size="small"
            sx={{
              height: 20,
              fontSize: '0.7rem',
              '& .MuiChip-label': { px: 0.5 },
            }}
          />
        );
      default:
        return (
          <Chip
            icon={<CheckCircleOutlineIcon sx={{ fontSize: 14 }} />}
            label="Unverified"
            variant="outlined"
            size="small"
            sx={{
              height: 20,
              fontSize: '0.7rem',
              borderColor: theme.palette.text.secondary,
              color: theme.palette.text.secondary,
              '& .MuiChip-label': { px: 0.5 },
            }}
          />
        );
    }
  }, [kycStatus, theme.palette.text.secondary]);

  return (
    <>
      <ListItem button onClick={handleAvatarDrawerToggle}>
        <ListItemIcon>
          <Avatar
            src={user.profile_image ? `${ProfilePath}${user.profile_image}` : undefined}
            alt="Profile Avatar"
            sx={{ width: 40, height: 40 }}
          />
        </ListItemIcon>

        <ListItemText
          primary={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body1" noWrap>
                {user.username || 'User'}
              </Typography>
              {statusChip}
            </Box>
          }
        />

        <ChevronRightIcon sx={{ color: theme.palette.text.secondary }} />
      </ListItem>

      <ProfileInfo open={avatarDrawerOpen} onClose={handleAvatarDrawerToggle} />
    </>
  );
};

export default ProfileSection;
